import * as IPurchases from '../../../../../interfaces/merchants/products/purchases';
import * as IInputs from '../../../../../interfaces/merchants/products/purchases/inputs';

export const withUserInfo = (
  userInfo: IInputs.UserInfo,
): IPurchases.PurchasingRequestInput => {
  const struct: IPurchases.PurchasingRequestInput = {};

  const { customerFields } = userInfo;

  const attributes: IPurchases.PurchasingRequestCustomerCustomFieldsAttribute[] = [];
  if (customerFields) {
    Object.keys(customerFields).forEach(k => {
      if (customerFields[k] !== '') {
        attributes.push({ binder_id: k, value: customerFields[k] });
      }
    });
  }

  struct.customer_custom_fields = {
    customer_custom_field_responses_attributes: attributes,
  };

  return struct;
};

const toPaymentMethod = (
  payment: IInputs.Payment,
): IPurchases.PurchasingRequestPaymentMethod => {
  if (payment.selection === IPurchases.PaymentSelection.AnotherCreditCard) {
    // カード利用歴があるが、新しく生成する
    return {
      ctok: payment.token,
      method: 'credit_card',
      restore_credit_card: false,
    };
  }
  if (payment.selection === IPurchases.PaymentSelection.UsedCreditCard) {
    // カード利用歴があり、以前のカードを利用する
    return {
      method: 'credit_card',
      restore_credit_card: true,
    };
  }
  throw new Error(`cannot create payment: payment ${payment}`);
};

export const withPayment = (
  payment: IInputs.Payment,
): IPurchases.PurchasingRequestInput => ({
  payment_method: toPaymentMethod(payment),
});
